import Vue from "vue";
import UserDefinition from '~/definitions/userDefinition'

export default Vue.extend({
  filters: {
    initials(user) {
      if (user.first_name || user.last_name) {
        return `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`.toUpperCase();
      } else if (user.email) {
        return user.email.match(/^.{1,2}(?=.*@)/)[0].toUpperCase();
      } else if (user.name) {
        return user.name.slice(0, 2).toUpperCase();
      }
    },
    firstName(user) {
      if (user.first_name) {
        return user.first_name;
      } else if (user.email) {
        return user.email.match(/.+?(?=@)/)[0];
      }
    },
    lastName(user) {
      if (user.last_name) {
        return user.last_name;
      } else if (user.email) {
        return user.email.match(/.+?(?=@)/)[0];
      }
    },
    fullName(user, email: boolean = true) {
      return UserDefinition.fullName(user, email);
    }
  }
});
